module.exports = __webpack_public_path__ + "assets/img/AuditCover.9d864bf1.jpg";